module.exports = __webpack_public_path__ + "img/map.f6fb0d80.png";